import styled from "@emotion/styled";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 389px;

  padding: 20px 24px 24px;

  background-color: ${({ isStatusError, isStatusSuccess, theme }) =>
    isStatusError
      ? theme.colors.error.light
      : isStatusSuccess
        ? theme.colors.accent.green
        : theme.colors.white};

  border-radius: ${p => p.theme.space[4]}px;
  gap: ${p => p.theme.space[4]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    max-width: 320px;
    ${({ height }) => height && `height: ${height}`}
  }
`;

const InfoWrapper = styled.div``;

const Title = styled.p`
  margin-bottom: ${p => p.theme.space[4]}px;

  font-size: ${p => p.theme.fontSizes.xl};
  font-weight: ${p => p.theme.fontWeight.medium};
  line-height: 1.25;

  color: ${({ status, theme }) =>
    status === "error" ? theme.colors.white : theme.colors.black};
`;

const Text = styled.p`
  font-size: ${p => p.theme.fontSizes.s};
  font-weight: ${p => p.theme.fontWeight.normal};
  line-height: 1.5;

  color: ${({ status, theme }) =>
    status === "error" ? theme.colors.white : theme.colors.black};
`;

export { Wrapper, Title, Text, InfoWrapper };
